import { Commit } from 'vuex';
import { SuiviDemandeInterventionState } from './state';

export enum DemandeInterventionActions {
    GET_DEMANDES_INTERVENTION = 'GET_DEMANDES_INTERVENTION',
    NAV_FILTER = 'NAV_FILTER_DEMANDES_INTERVENTIONS',
    GET_ATTACHMENT = 'GET_ATTACHMENT',
    EXPORT_XLS = 'EXPORT_XLS',
    SEND_ASK_INTERVENTION_REMINDER = 'SEND_ASK_INTERVENTION_REMINDER'
}

export interface DemandeInterventionActionTypes{
    commit: Commit,
    state: SuiviDemandeInterventionState,
    getters: any
}
